angular.module(NgAppName).directive('iframeOnLoad', [function(){
	return {
    scope: {
			// iframeOnLoad: '='
			callback: '=iframeOnLoad'
    },
    link: function(scope, element, attrs){
			element.on('load', function(){
				scope.callback();
			});
    }
}}]);
